import { Box } from '@material-ui/core';
import * as React from 'react';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  onFocus?: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  className?: string;
  dataFd: string;
};
export const AccessibilityButton = (props: Props) => {
  return (
    <button
      aria-live="polite"
      data-fd={props.dataFd}
      className={props.className}
      onClick={props.onClick}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        padding: 0
      }}
    >
      {props.children}
    </button>
  );
};
